__turbopack_context__.v({
  "fundraiserBar": "ChartSkeleton-module-scss-module__pNSyZW__fundraiserBar",
  "fundraiserName": "ChartSkeleton-module-scss-module__pNSyZW__fundraiserName",
  "shimmer": "ChartSkeleton-module-scss-module__pNSyZW__shimmer",
  "wrapper": "ChartSkeleton-module-scss-module__pNSyZW__wrapper",
});
